import React, {useState, useEffect} from 'react';
import FacturacionGeneral from "./views/FacturaGeneral/FacturacionGeneral";
import FacturacionRestaurante from "./views/FacturaRestaurante/FacturacionRestaurante";
import FacturaEcommerce from "./views/FacturaEcommerce/FacturaEcommerce";
import ConsultaFacturas from "./views/Consultas/ConsultaFacturas";
import FacturacionMoto from "./views/FacturaMoto/FacturacionMoto";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFileInvoiceDollar, faUtensils, faFileInvoice, faSearchDollar} from '@fortawesome/free-solid-svg-icons'
import logo from './assets/img/logo.svg';
import Swal from 'sweetalert2';
import {scroller, Element} from "react-scroll";
import {useDispatch} from "react-redux";
import {FACTURA_CONSULTAS, FACTURA_GENERAL, FACTURA_ECOMMERCE, FACTURA_RESTAURANTE, FACTURA_MOTO} from "./constants/enviroment";
import getTiendas from "./actions/catalogos/tiendasAction";
import getRegimenFiscal from "./actions/catalogos/regimenFiscalAction";
import getUSO_CFDI from "./actions/catalogos/usoCFDIAction";
import {setLimpiarParametros} from "./actions/busqueda/busquedaAction";
import {setLimpiarFacturacion} from "./actions/otros/facturacionAction";

function App() {
    const dispatch = useDispatch();
    const [activeIndex, setActiveIndex] = useState(FACTURA_GENERAL);

    const handleOnClick = (event, index) => {
        event.preventDefault();
        setActiveIndex(index);
        dispatch(setLimpiarParametros());
        dispatch(setLimpiarFacturacion());
        scroller.scrollTo('start', {
            duration: 800,
            smooth: true
        });
    };

    useEffect(() => {
        dispatch(getTiendas());
        dispatch(getUSO_CFDI());
        dispatch(getRegimenFiscal());
        mostrarAviso();
    }, []);

    const Switch = () => {
        switch (activeIndex) {
            case FACTURA_GENERAL:
                return <FacturacionGeneral/>;
            case FACTURA_RESTAURANTE:
                return <FacturacionRestaurante/>;
            case FACTURA_ECOMMERCE:
                return <FacturaEcommerce/>;
            case FACTURA_CONSULTAS:
                return <ConsultaFacturas/>;
            case FACTURA_MOTO:
                return <FacturacionMoto/>;
            default:
                return <FacturacionGeneral/>;
        }
    };

    const mostrarAviso = () => {
        Swal.fire({
            title: '<strong>Comunicado de facturación</strong>',
            width: 900,
            padding: '3em',
            html:  '<p align="justify">Estimado cliente se le comunica que de conformidad con las disposiciones fiscales publicadas por ' +
                    '<strong>Secretaría de Administración Tributaria</strong> relativas a Comprobantes digitales (CFDI), a partir del día 20/02/2023, ' + 
                    'nuestro sistema de facturación se actualiza a la versión 4.0.<br>' +
                    'Dicha versión considera nuevos datos fiscales obligatorios que deben coincidir con su ' +
                    '<strong>Constancia de Situación Fiscal</strong>, tales como: </p>' +
                    '<div align="left"><ul><li>RFC</li><li>Nombre o Razón social sin incluir el régimen de capital</li><li>Código postal</li><li>Régimen fiscal</li><li>Uso del comprobante</li></ul></div>' +
                    '<p align="justify">Es importante puntualizar que en caso de que sus datos no coincidan con los de la Constancia de Situación Fiscal, ' +
                    'NO podrá ser generada su factura. Favor de tener toda su información a la mano.</p>'
        })
    };

    return (
        <div className="App" id="App">
            <header>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <img src={logo} alt="" height="49px"/>
                        </div>
                    </div>
                </div>
            </header>

            <main>
                <section className="intro">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <h1 className="intro__heading-primary">Portal facturación en Línea</h1>
                                <h3 className="intro__heading-secondary">Factura tus compras del mes o recupéralas</h3>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="elementos">
                    <div className="container">
                        <div className="row justify-content-md-center">
                            <div className="col-sm-12 col-md-6 col-lg-3">
                                <a className={`nostyle ${activeIndex === FACTURA_GENERAL ? "active" : ""}`}
                                   onClick={(event) => handleOnClick(event, FACTURA_GENERAL)}>
                                    <div className="feature-box">
                                        <FontAwesomeIcon className="feature-box__icon" icon={faFileInvoiceDollar}/>
                                        <h3 className="heading-tertiary u-margin-bottom-small">Factura Tienda</h3>
                                        <p className="feature-box__text">
                                            Factura tus compras realizadas en cualquiera de nuestras tiendas.
                                        </p>
                                    </div>
                                </a>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-3">
                                <a className={`nostyle ${activeIndex === FACTURA_RESTAURANTE ? "active" : ""}`}
                                   onClick={(event) => handleOnClick(event, FACTURA_RESTAURANTE)}>
                                    <div className="feature-box">
                                        <FontAwesomeIcon className="feature-box__icon" icon={faUtensils}/>
                                        <h3 className="heading-tertiary u-margin-bottom-small">Factura Restaurante</h3>
                                        <p className="feature-box__text">
                                            Factura tus consumos hechos en cualquiera de nuestros
                                            restaurantes.
                                        </p>
                                    </div>
                                </a>
                            </div>
                            {/*<div className="col-sm-12 col-md-6 col-lg-3">
                                <a className={`nostyle ${activeIndex === FACTURA_ECOMMERCE ? "active" : ""}`}
                                   onClick={(event) => handleOnClick(event, FACTURA_ECOMMERCE)}>
                                    <div className="feature-box">
                                        <FontAwesomeIcon className="feature-box__icon" icon={faFileInvoice}/>
                                        <h3 className="heading-tertiary u-margin-bottom-small">Factura Tienda en Línea</h3>
                                        <p className="feature-box__text">
                                            Factura tus compras realizadas en nuestra tiendas en línea.
                                        </p>
                                    </div>
                                </a>
                            </div>
                            */}
                            <div className="col-sm-12 col-md-6 col-lg-3">
                                <a className={`nostyle ${activeIndex === FACTURA_CONSULTAS ? "active" : ""}`}
                                   onClick={(event) => handleOnClick(event, FACTURA_CONSULTAS)}>
                                    <div className="feature-box">
                                        <FontAwesomeIcon className="feature-box__icon" icon={faSearchDollar}/>
                                        <h3 className="heading-tertiary u-margin-bottom-small">Consultar Factura</h3>
                                        <p className="feature-box__text">
                                            Recupera tus documentos fiscales generados con nosotros.
                                        </p>
                                    </div>
                                </a>
                            </div>
                        </div>

                        <Element name="start">
                            <p className="elementos__intro-text">
                                <span><strong>Estimado Cliente:</strong></span><br/>
                                Le informarnos que, para su facilidad, usted puede facturar en el "Módulo de
                                Servicio al
                                Cliente" de cada una de nuestras tiendas (Independientemente de la Tienda donde
                                realizó la
                                compra), La factura solo puede ser Expedida Máximo hasta el último día del mes de
                                Compra.{' '}
                                <strong>Tiendas Chapur S.A. de C.V.</strong>, cumple con las disposiciones fiscales
                                vigentes para la emisión de
                                CFDI.
                                Los datos que se solicitan para dicho comprobante son: RFC y su correo electrónico
                                para el envío de los comprobantes. <br/>
                                Para Contactarnos llame a los números {' '}<a href="tel:9302800"><strong>930-28-00</strong></a>{' '}
                                Ext. 2363 y 6085 Para las tiendas de Mérida,
                                {' '}<a href="tel:(988) 887-23-45"><strong>(988) 887-23-45</strong></a>{' '} Ext 3008 para la tienda
                                Cancún, en donde tendremos el gusto de atenderlo.
                            </p>
                        </Element>

                        {/*<div className="col-md-4">
                            <a className={`nostyle ${activeIndex === FACTURA_MOTO ? "active" : ""}`}
                                onClick={(event) => handleOnClick(event, FACTURA_MOTO)}>
                                <div className="feature-box-small">
                                    <FontAwesomeIcon className="feature-box__icon" icon={faMotorcycle}/>
                                    <h3 className="heading-tertiary u-margin-bottom-small">Factura Moto</h3>
                                </div>
                            </a>
                        </div>*/}
                    </div>
                </section>
                <Switch/>
            </main>

            <footer>
                <div className="footer container">
                    <div className="wrap row">
                        <div className="col-xs-12 col-lg-2">
                            <div className="row d-flex flex-wrap">
                                <div className="col-xs-12 col-sm-4 col-lg-12 attention-lines footer-section">
                                    <div className="footer__subtitle">Líneas de atención</div>
                                    <div className="attention-lines__phone mb-10"> 999 930 2800</div>
                                    <div className="attention-lines__schedule mb-10">Horario de atención:<br/> Lunes a
                                        Domingo de 9:00 a
                                        21:00 horas.
                                    </div>
                                    <div className="attention-lines__mail">Correo: contacto@chapur.com</div>
                                </div>
                                <div className="col-xs-12 col-sm-4 col-lg-12 stores footer-section hidden-xs">
                                    <div className="footer__subtitle">Nuestras tiendas</div>
                                    <a className="btn btn--large btn--gray stores__btn text-white"
                                       onClick={(event) => handleOnClick(event, FACTURA_MOTO)}>
                                       Factura Moto
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div className="col-xs-12 col-lg-9 col-lg-offset-1 footer-section">
                            <div className="links footer-section">
                                <div className="row">
                                    <ul className="links-column col-sm-3">
                                        <div className="footer__subtitle">Servicios Chapur</div>
                                        <li><a
                                            href="https://www.chapur.com.mx/restaurant">Restaurante</a></li>
                                        <li><a href="https://mesaderegalos.chapur.com.mx/" target="_blank"
                                               rel="noopener">Mesa de
                                            Regalos</a></li>
                                        <li><a
                                            href="https://www.chapur.com.mx/sastreria">Sastrería</a></li>
                                        <li><a href="https://bellasrecompensas.chapur.com.mx/br.php" target="_blank"
                                               rel="noopener">Bellas
                                            Recompensas</a></li>
                                    </ul>
                                    <ul className="links-column col-sm-3">
                                        <div className="footer__subtitle">Ayuda</div>
                                        <li><a
                                            href="https://www.chapur.com.mx/contact">Contáctanos</a></li>
                                        <li><a
                                            href="https://www.chapur.com.mx/delivery">Envíos y Entregas</a>
                                        </li>
                                        <li><a href="https://www.chapur.com.mx/returns">Devoluciones
                                            y Cambios</a>
                                        </li>
                                        <li><a href="http://chapur63.chapur.com/FactWeb/" target="_blank"
                                               rel="noopener">Facturación</a></li>
                                        <li><a href="https://www.chapur.com.mx/faq">Preguntas
                                            frecuentes</a></li>
                                    </ul>
                                    <ul className="links-column col-sm-3">
                                        <div className="footer__subtitle">Crédito Chapur</div>
                                        <li><a href="http://chapur63.chapur.com/Presol/" target="_blank" rel="noopener">Solicita
                                            tu
                                            tarjeta</a></li>
                                        <li><a href="https://chapur63.chapur.com/CrediWeb/" target="_blank"
                                               rel="noopener">Checar mi
                                            Estado de Cuenta</a></li>
                                        <li><a href="https://chapur63.chapur.com/CrediWeb/" target="_blank"
                                               rel="noopener">Pagar mi
                                            Cuenta</a></li>
                                        <li><a
                                            href="https://www.chapur.com.mx/app-movil">Nuestra App Chapur</a>
                                        </li>
                                    </ul>
                                    <ul className="links-column col-sm-3">
                                        <div className="footer__subtitle">Acerca</div>

                                        <li><a
                                            href="https://www.chapur.com.mx/localizador-de-tiendas">Tiendas</a></li>
                                        <li><a
                                            href="https://www.chapur.com.mx/about">Historia</a></li>
                                        <li><a href="https://chapur.fortia.com.mx/BolsaTrabajoPrime/Candidato/LogIn"
                                               target="_blank"
                                               rel="noopener">Bolsa de trabajo</a></li>
                                        <li><a href="https://chapur63.chapur.com/chapur.com" target="_blank"
                                               rel="noopener">Portal
                                            de Negocios</a></li>
                                        <div className="visible-lg">
                                            <div className="social">
                                                <div className="social__title footer__subtitle">Síguenos en nuestras
                                                    redes
                                                </div>
                                                <div className="social__items">
                                                    <a className="social__item icon-facebook" rel="noopener"
                                                       target="_blank"
                                                       href="https://www.facebook.com/GranChapur"></a>
                                                    <a className="social__item icon-youtube" rel="noopener"
                                                       target="_blank"
                                                       href="https://www.youtube.com/user/GranChapur"></a>
                                                    <a className="social__item icon-instagram" rel="noopener"
                                                       target="_blank"
                                                       href="https://www.instagram.com/Granchapur/"></a>
                                                </div>
                                            </div>
                                        </div>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

            <div className="institutional bgc-gray">
                <div className="container-fluid">
                    <div className="text-center text-white font-raleway p-10">© Chapur 2022 - {' '} 
                        <a className="text-white" href="https://www.chapur.com.mx/privacy">Aviso de privacidad</a> &amp; {' '}
                        <a className="text-white" href="https://www.chapur.com.mx/terms-conditions">Términos y Condiciones</a>
                        <p>v2.0.0</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default App;